//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: 'pay',
    components: {},
    data() {
        return {
            radio: '2',
            show: false,
            value: '',
            showKeyboard: true,
            pageShow: false,
            id: 0,
            orderDetail: {
                orderDetails: []
            },
            shop: {},
            currrentMemberPoint: 0,// 当前用户账号积分,
            refreshing: false,
            saving: false
        };
    },
    methods: {
        init() {
            if (this.id === 0) {
                return;
            }
            this.getOrderDetail(this.id);
        },
        clickPayBtn() {
            this.show = true;
        },
        onInput(key) {
            this.value = (this.value + key).slice(0, 6);
            // console.log('length:%@', this.value.length);
            // console.log('value:%@', this.value);
            var l = this.value.length;
            if (l === 6) {
                var p = {
                    paymentCode: this.value
                };
                this.$toast.loading({
                    duration: 0,
                    message: '加载中…'
                });
                abp.ajax.post('/api/services/app/Member/IsCheckPaymentCode', p)
                    .then(res => {
                        console.log(res);
                        this.pay();
                    }, error => {
                        console.log(error);
                        this.value = '';
                        this.$toast.clear();
                    })
                    .catch(() => {
                    })
                    .then(() => {
                        this.refreshing = false;
                        this.$toast.clear();
                    });
            }
        },
        pay() {
            this.$toast.loading({
                duration: 0,
                message: '支付中…'
            });
            var p = {
                id: this.orderDetail.id,
                status: 1
            };
            abp.ajax.post('/api/services/app/Order/ChangeStatus', p).then(res => {
                console.log(res);
                this.value = '';
                this.show = false;
                this.pageShow = true;
            }).catch((error) => {
                console.log(error);
                this.value = '';
                this.$toast.clear();
            }).then(() => {
                this.refreshing = false;
                this.$toast.clear();
            });
            console.log(p);
        },
        onDelete() {
            this.value = this.value.slice(0, this.value.length - 1);
        },
        getOrderDetail(id) {
            abp.ajax.get('/api/services/app/Order/GetOrderById?id=' + id).then(res => {
                this.orderDetail = {};
                this.orderDetail = res.data.result;
                console.log('orderDetail：%@', res.data.result);
                // this.getShop(this.orderDetail.shopId);
            });
        },
        getShop(id) {
            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + id).then(res => {
                this.shop = {};
                this.shop = res.data.result;
            });
        },
        closePageShow() {
            this.pageShow = false;
        },
        getCurrentPoint() {
            abp.ajax.get('/api/services/app/PointAccount/GetCurrentPoint').then(res => {
                this.currrentMemberPoint = res.data.result;
            });
        },
        getMyMember() {
            abp.ajax.get('/api/services/app/Member/GetMyMember').then((res) => {
                if (res.data.result.isHavPaymentPwd) {
                    this.init();
                } else {
                    this.$router.push({
                        name: 'payment_code'
                    });
                }
            });
        },
        myOrders() {
            this.$router.replace({name: 'my-order'})
        }

    },
    created() {
        this.id = parseInt(this.$route.params.id || 0);
        this.init();
        // this.getMyMember();
        this.getCurrentPoint();
    }
};
